// Generated by CoffeeScript 1.12.7
angular.module(__filename, ['ui.router']).config([
  '$urlMatcherFactoryProvider', function($urlMatcherFactoryProvider) {
    return $urlMatcherFactoryProvider.strictMode(false);
  }
]).run([
  '$rootScope', '$log', function($rootScope, $log) {
    return $rootScope.$on('$stateChangeError', function(e, toState, toParams, fromState, fromParams, err) {
      $log.error("Failed to transition from state '" + fromState.name + "' to state '" + toState.name + "'. See below error for details:");
      throw err;
    });
  }
]);

module.exports = __filename;
